import { EnvMap } from "./EnvMap"

const _map = new EnvMap()
export const envVar = {
  init: (map: { [key: string]: unknown }) => {
    _map.init(map)
  },
  getMap: () => {
    return _map.getMap()
  },
  getValue: (key: string) => {
    return _map.get(key)
  },
}
